export function frontApiUrl(path: string) {
    if (typeof window === 'undefined') {
        return `http://localhost:${process.env.PORT}${path}`;
    }
    return path;
}
